export default __webpack_public_path__ + "static/media/notification.4da05468.mp3";